<template>
  <footer class="app-footer">
    <div class="footer-box">
      <div class="footer-box-info">
        <svg-icon
          icon-class="footerLogo"
          class="logo-icon"
        ></svg-icon>
        <div class="footer-info"></div>
        <div class="footer-copyright">Reborn 設計學院 © 2019-2021 All Rights Reserved.</div>
      </div>
      <div class="footer-link-nav">
        <div class="footer-link">
          <div class="footer-link-title">關於我們</div>
          <div class="footer-link-inner">
            <router-link to="/about-us">團隊介紹</router-link>
            <router-link to="/user-term">使用者條款</router-link>
            <router-link to="/private-policy">隱私權政策</router-link>
          </div>
        </div>
        <div class="footer-link">
          <div class="footer-link-title">學員服務</div>
          <div class="footer-link-inner">
            <router-link to="/question-answer">常見問題</router-link>
            <a href="https://www.facebook.com/messages/t/reborn.academy" target="_blank">聯絡客服</a>
          </div>
        </div>
        <div class="footer-link">
          <div class="footer-link-title">聯絡方式</div>
          <div class="footer-link-inner">
            <a href="https://www.facebook.com/reborn.academy" target="_blank">Facebook 官方粉絲專頁</a>
            <div>Email：co-op@reborn.in</div>
          </div>
        </div>
      </div>
      <div class="footer-copyright-mobile">Reborn 設計學院 © All Rights Reserved.</div>
    </div>
  </footer>
</template>
<script>

export default {
  name: 'AppFooter'
}
</script>
<style lang="scss" scoped>
.app-footer {
  width: 100%;
  color: rgba(255, 255, 255, 0.7);
  background: #25282B;

  .footer {

    &-box {
      max-width: 1170px;
      width: 100%;
      padding: 60px;
      display: flex;
      justify-content: space-between;
      margin: auto;

      .logo-icon {
        height: 50px;
        width: 120px;
        margin-bottom: 34px;
      }

      &-info {
        width: 40%;
      }
    }

    &-info {
      width: 100px;
      height: 100px;
    }

    &-copyright {
      font-size: 12px;
    }

    &-link-nav {
      width: 60%;
      display: flex;
      justify-content: space-between;
    }

    &-link {
      display: flex;
      flex-direction: column;
    }

    &-link-title {
      font-size: 16px;
      font-weight: bold;
      cursor: text;
      color: white;
    }

    &-link-inner {
      display: flex;
      flex-direction: column;
      margin-top: 30px;

      & a {
        font-size: 14px;
        margin-bottom: 12px;
        color: rgba(255, 255, 255, 0.7);
      }

      & div {
        font-size: 14px;
        margin-bottom: 12px;
        color: rgba(255, 255, 255, 0.7);
      }

      & a:hover {
        color: white;
      }
    }

    &-copyright-mobile {
      display: none;
    }
  }
}

@media( max-width: 1023px ){

.app-footer {
  padding: 0px;

  .footer {

    &-box {
    padding: 20px 14px 40px;
    flex-direction: column;

      .logo-icon {
        margin-left: 3%;
      }

      &-info {
        width: 100%;
      }
    }

    &-info {
      display: none;
    }

    &-copyright {
      display: none;
    }

    &-link-nav {
      width: 100%;
      flex-wrap: wrap;
      margin-bottom: 40px;
    }

    &-link {
      margin-left: 5%;
      width: 45%;

      &:nth-child(3) {
        margin-top: 30px;
      }
    }

    &-link:last-child {
      width: 100%;
    }

    &-link-inner {

      & a {
        margin-right: 12px;
      }

      & div {
        margin-right: 12px;
      }
    }

    &-copyright-mobile {
      display: block;
      font-size: 12px;
    }
  }
}

}

</style>



// WEBPACK FOOTER //
// src/components/layout/AppFooter.vue